import http from "@/api/http.js";

export function getProductsRelated(unificado) {
  return http
    .get(`Products_base_relation/get_single_related_products/${unificado}`)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}

export function productRelatedDelete(unificado) {
  return http
    .delete(`products_base_relation/delete_product?unificado=${unificado}`)
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}

export function productVariationInsert(unificado, unificadoVariation) {
  return http
    .post(`products_base_relation/new_relation`, {
      relation: {
        unificado: unificado,
        unificado_related: unificadoVariation
      }
    })
    .then(res => {
      return res;
    })
    .catch(e => {
      throw e;
    });
}
